import { observer } from "mobx-react-lite";
import { useTranslations } from "next-intl";

import { BracketsSelector } from "@/components/doc/right-sidebar/active-node-style/group/BracketsSelector";
import { hasGroupBounds } from "@/components/expression/utils/matrix";
import { FormToggle } from "@/components/form/FormToggle";
import { twMerge } from "@/utils/twMerge";

import type { GroupNodeModel } from "@/models/nodes/GroupNodeModel";

type Props = {
  node: GroupNodeModel;
};

export const GroupBracketsSelector = observer(function GroupBracketsSelector({ node }: Props) {
  const t = useTranslations("sidebar.activeNode");
  const { doc } = node;

  const handleOnToggleChange = () => {
    const omitParentheses = !node.omitParentheses;

    doc.transact(() => {
      node.omitParentheses = omitParentheses;
    }, "GroupBracketsSelector:handleOnToggleChange");
    doc.focus();
  };

  const showToggle =
    node.matrixNode && hasGroupBounds(node.matrixNode.bounds) && node.decorators.length > 0;

  return (
    <>
      {showToggle && (
        <label
          htmlFor={`omit-group-parentheses-toggler-${node.id}`}
          aria-label={t("fields.showParentheses")}
          className={twMerge(
            "flex items-center cursor-pointer text-xxs tracking-tight py-1.25 uppercase",
          )}
        >
          {t("fields.showParentheses")}
          <FormToggle
            id={`omit-group-parentheses-toggler-${node.id}`}
            checked={!node.omitParentheses}
            className="ml-auto"
            onClick={(e) => e.stopPropagation()}
            onChange={handleOnToggleChange}
            asInput
          />
        </label>
      )}
      <BracketsSelector node={node} displayLimit={5} className="mb-[5px]" />
    </>
  );
});
